import { Box, Typography } from '@mui/material';

interface TitleBarProps {
  text: string;
}

export function TitleBar({ text }: TitleBarProps) {
  return (
    <Box
      sx={{
        boxShadow: '0px 3px 5px 0px rgba(0,0,0,0.75)', // Sombra
        color: '#FFFFFF', // Texto blanco
        backgroundColor: '#133385', // Fondo azul oscuro
        borderRadius: '5px', // Bordes redondeados
        display: 'flex', // Asegura el alineamiento
        alignItems: 'center', // Centra el contenido verticalmente
        padding: 1, // Espaciado interno
      }}
    >
      <Typography sx={{ fontWeight: 700, fontSize:24, textAlign: 'left', ml: 1  }}>{text}</Typography>
    </Box>
  );
}
